


import { KTCard } from '../../../_dashboard/helpers'
import { About } from './About'
import { ListViewProvider, useListView } from './about-details/core/ListViewProvider'
import { QueryRequestProvider } from './about-details/core/QueryRequestProvider'
import { QueryResponseProvider } from './about-details/core/QueryResponseProvider'

const AboutComponent = () => {
  const {itemIdForUpdate} = useListView()
  return (
    <>
      <KTCard>
     <About/>
      </KTCard>
    </>
  )
}

const AboutListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <AboutComponent />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {AboutListWrapper}
